/*
 * Post-restaurant.ts
 * Description: Includes the declaration
 * of the function for creating a restaurant
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing required global variables
import {APIURL} from '@/ts/variables';
// Importing functions
import {getRestaurants} from '@/ts/restaurants/get-restaurants';
// Importing an interface
import {Restaurant} from '@/ts/restaurants/validate-restaurant';

/**
 * Creating a restaurant
 *
 * @return {Object} Promise - when the restaurant is created
 * @param {Restaurant} data - restaurant data
 */
export function postRestaurant(data: Restaurant) {
    const jwt = localStorage.getItem('jwt');
    return new Promise((resolve, reject) => {
        Axios({
            url:  APIURL + 'restaurants',
            method: 'post',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {
                ...data,
                working_hours: JSON.stringify(data.working_hours),
                tags: JSON.stringify(data.tags),
                delivery_prices: JSON.stringify(data.delivery_prices),
            },
        }).then(() => {
            resolve();
        }).catch(() => {
            reject();
        });
    });
}

/**
 * Creating a delivery town for a restaurant
 *
 * @return {Object} Promise - when the town is added
 * @param {String} ekatte - number of a town
 * @param {String} slug - id of a restaurant
 */
export function postTown(ekatte: string, slug: string) {
    const jwt = localStorage.getItem('jwt');
    return new Promise((resolve, reject) => {
       Axios({
           url:  APIURL + 'restaurants/' + slug + '/towns',
           method: 'post',
           headers: {
               Authorization: 'Bearer ' + jwt,
           },
           data: {
               town_ekatte: ekatte,
           },
       }).then(() => {
           // TODO: Check if this can be avoided
           getRestaurants().finally(() => {
                resolve();
           });
       }).catch(() => {
           reject();
       });
   });
}

/**
 * Correcting restaurant data before creating
 *
 * @param {Restaurant} data - restaurant data
 */
export function correctDataCreate(data: Restaurant) {
    // Getting an instance of the first day
    const hours = data.working_hours.find((item) => item.day === 'Monday');
    // Setting up the next days
    data.working_hours.push({ day: 'Tuesday', start: hours.start, end: hours.end });
    data.working_hours.push({ day: 'Wednesday', start: hours.start, end: hours.end });
    data.working_hours.push({ day: 'Thursday', start: hours.start, end: hours.end });
    data.working_hours.push({ day: 'Friday', start: hours.start, end: hours.end });
    // Turning delivery gifts from a string to an array of strings
    for (const [index, item] of Object.entries(data.delivery_prices)) {
        data.delivery_prices[index].gift = data.delivery_prices[index].gift.split(',');
    }
}
